export const isMigrateWorkflowPage = (): boolean => {
  const pathname = window.location.pathname;
  return pathname.endsWith('migrate') || pathname.endsWith('activate');
};
